module.exports = __webpack_public_path__ + "media/images/products/category/sm/5-a43a4c325bbbe3d2e9c774da8f3b3a18.jpg";